import * as yup from "yup";

export const TimeSheetCategoriesSetupValidationSchema = yup.object().shape({
  
});
